import { FreeGameType } from '../../buybonus/enum/buyBonusEnum'
import { GodziDropResultResponse, IGodziDropEventInfo } from '../../placeOrder/api/PlaceOrderResponse'
import { create } from 'zustand'

export interface IGodziStore {
  eventInfo: IGodziDropEventInfo
  godziResult: GodziDropResultResponse
  isGodziTime: boolean
  godziDropFreeGameType: FreeGameType
  godziRoundIndex: number
  isGodziEnd: boolean
  isShowDashboard: boolean
  isShowFreeSpinBtn: boolean
  freeSpinCount: number
  isShowGodziFire: boolean
}

export const useGodziDropStore = create<IGodziStore>(_ => ({
  eventInfo: {
    isIconOpen: false,
    isOngoing: false,
    promotionId: 0,
  },
  godziResult: {
    stake: 0,
    type: 0,
    prize: 0,
    roundGameResult: [],
    payout: 0,
    freeGameCount: 0,
  },
  isGodziTime: false,
  godziDropFreeGameType: FreeGameType.MainGame,
  godziRoundIndex: 0,
  isGodziEnd: false,
  isShowDashboard: false,
  isShowFreeSpinBtn: false,
  freeSpinCount: 0,
  isShowGodziFire: false,
}))
